import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { faLocationDot, faPhone, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faHeart,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import { faFacebookF, faInstagram, faLinkedin, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {

  const lnks = [
    {
      name: "Home",
      BaseLink: "/",
    },
    {
      name: "About Us",
      BaseLink: "/about-us",
    },
    {
      name: "Products",
      BaseLink: "/all-products",
    },
    {
      name: "Contact Us",
      BaseLink: "/contact-us",
    },
    {
      name: "Terms & Conditions",
      BaseLink: "/termsandconditions",
    },
    {
      name: "Privacy Policy",
      BaseLink: "/privacypolicy",
    },
    {
      name: "FAQs",
      BaseLink: "/faq",
    },
  ];
  return (
    <>
      <section className="footer_div">
        <div className="footlogdiv">
          <Link to={'/'}>
            <img className="footlogo" src={process.env.PUBLIC_URL + '/assets/images/logo/logo.png'} alt="footer-logo" />
          </Link>
        </div>

        <Container>
          <Row >
            <Col xxl={8}
              xl={9}
              lg={10}
              md={11}
              sm={11}
              xs={12}
              className="mx-auto">
              <div className="footermain_div">
                <div className="footer_top">
                  <div className="flexmenus  flex-wrap">
                    {lnks.map((text, index) => (
                      <div className="top_div_footer  ">
                        <Link to={text.BaseLink}>
                          <p className="top_text px-2">{text.name}</p>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="footer_miidle">
                  <Row>
                    <Col
                      xxl={8}
                      xl={8}
                      lg={7}
                      md={8}
                      sm={10}
                      xs={12}
                      className="mx-auto"
                    >
                      <div className="top_div_footer">
                        <div className="addres_div padding_div">
                          <p className="top_text"><FontAwesomeIcon icon={faLocationDot} /> Flat No.102, Rajgad Heights, Phaltan Road, Kasba, Baramati-413102</p>
                        </div>
                        <div className="contact_div padding_div">
                          <p className="top_text">
                            <FontAwesomeIcon icon={faPhone} className="footericn" />{" "}
                            +91- 8766701045 / 7721091787
                          </p>
                          <p className="top_text">
                            <FontAwesomeIcon icon={faEnvelope} className="footericn" />
                            {" "}
                            scroma1001@gmail.com
                          </p>

                        </div>

                        <div className="all_icon padding_div">

                          <Link to={"/"} target="blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon icon={faLinkedin} className="cart_logo" />
                            </div>
                          </Link>

                          <Link to={"https://www.facebook.com/"} target="blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon className="cart_logo" icon={faFacebookF} />
                            </div>
                          </Link>

                          <Link to={"/"} target="blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon icon={faXTwitter} className="cart_logo" />
                            </div>
                          </Link>

                          <Link to={"https://www.instagram.com/"} target="blank">
                            <div className="headericn_div">
                              <FontAwesomeIcon icon={faInstagram} className="cart_logo" />
                            </div>
                          </Link>

                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>

                <hr className="bdbott"></hr>

                <p className="bottom_footer_text">
                  ©2025 Scroma Venture All Rights Reserved | <Link target="_blank" className="bottom_footer_text" to="https://profcymaglobal.com">Developed by Profcyma Solutions Pvt Ltd</Link>
                </p>
              </div>
            </Col>

          </Row>
        </Container>


      </section>
    </>
  );
};

export default Footer;
